import { createReducer, on } from '@ngrx/store'
import { TokenInterface } from '@shared/interfaces/app.state.interfaces'
import { terminosCondiciones } from '../actions/terminos-condiciones.actions'

export const initialState: TokenInterface = { token: '', exp: '' }

export const terminosCondicionesReducer = createReducer(
    initialState,
    on(terminosCondiciones, ((state, { item }) => {
        return { ...state, token: item.token, exp: item.exp }
    }))
)